<div mdbModal #loader="mdb-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="false" [config]="{keyboard: false, ignoreBackdropClick: true}">
    <div class="modal-dialog justify-content-center align-items-center modal-dialog-centered modal-sm" role="document">
        <img class="" width="60" src="assets/img/Loading.gif">
    </div>
</div>